import { Translations } from './fr';

export const it: Translations = {
  nav: {
    home: "Home",
    primeEvolution: "Evolution",
    pulse: "Pulse",
    sparkle: "Sparkle",
    agents: "Agenti",
    partners: "Partner",
    contact: "Contatto",
    recruitAgent: "Recluta Agente",
  },
  hero: {
    title: "Recluta i nostri",
    titleHighlight: "Agenti IA",
    titleEnd: "per Rafforzare i Tuoi Team",
    subtitle: "Collaboratori virtuali disponibili 24/7, formati sui tuoi processi aziendali, pronti a trasformare la tua produttività.",
    cta: "Recluta un Agente IA",
    discover: "Scopri Prime Evolution",
  },
  trust: {
    available: "Disponibile 24/7",
    secure: "100% Sicuro",
    agents: "Agenti Certificati",
    support: "Supporto Dedicato",
  },
  primeEvolution: {
    badge: "La Nostra Soluzione di Punta",
    title: "Prime Evolution",
    subtitle: "Il programma di accompagnamento completo per integrare l'IA nella tua azienda",
    description: "Prime Evolution è il nostro approccio olistico che combina audit, formazione e distribuzione di agenti IA personalizzati.",
    features: {
      audit: { title: "Audit Strategico", description: "Analisi approfondita dei tuoi processi per identificare opportunità di automazione." },
      training: { title: "Formazione Team", description: "Programmi di formazione adattati per una collaborazione efficace con l'IA." },
      deployment: { title: "Distribuzione Personalizzata", description: "Agenti IA personalizzati integrati con i tuoi strumenti esistenti." },
      support: { title: "Supporto Continuo", description: "Supporto dedicato e ottimizzazione continua." },
    },
    cta: "Inizia Prime Evolution",
    stats: { productivity: "Guadagno medio di produttività", roi: "Ritorno sull'investimento", satisfaction: "Tasso di soddisfazione" },
  },
  pulse: {
    badge: "Automazione Intelligente",
    title: "VEECTORIA Pulse",
    subtitle: "Automazione che pulsa al ritmo della tua azienda",
    description: "Pulse è la nostra piattaforma di automazione intelligente che connette e orchestra i tuoi workflow in tempo reale.",
    features: {
      connect: { title: "Connetti", description: "Integrazione nativa con oltre 200 strumenti professionali." },
      orchestrate: { title: "Orchestra", description: "Workflow intelligenti che si adattano automaticamente." },
      optimize: { title: "Ottimizza", description: "Analisi in tempo reale e raccomandazioni per migliorare i processi." },
    },
    cta: "Scopri Pulse",
  },
  advantages: {
    badge: "Perché Sceglierci",
    title: "Vantaggi VEECTORIA",
    subtitle: "Un approccio unico che combina competenza umana e potenza dell'IA",
    items: {
      expertise: { title: "Competenza Riconosciuta", description: "Oltre 10 anni di esperienza nella trasformazione digitale e IA." },
      custom: { title: "Soluzioni Personalizzate", description: "Ogni agente è specificamente addestrato sui tuoi processi." },
      security: { title: "Sicurezza Massima", description: "Dati ospitati in Europa, conformità GDPR garantita." },
      roi: { title: "ROI Garantito", description: "Impegno sui risultati con indicatori misurabili." },
      support: { title: "Supporto 24/7", description: "Team dedicato disponibile in qualsiasi momento." },
      evolution: { title: "Evoluzione Continua", description: "I tuoi agenti migliorano costantemente tramite machine learning." },
    },
  },
  sparkle: {
    badge: "Digitalizzazione Intelligente",
    title: "Sparkle",
    subtitle: "TagPDF v7 con IA",
    description: "Trasforma i tuoi documenti cartacei in dati utilizzabili con la nostra soluzione di digitalizzazione intelligente. Riconoscimento automatico, estrazione dati e classificazione intelligente.",
    features: {
      scan: {
        title: "Digitalizzazione Avanzata",
        description: "OCR ad alta precisione per tutti i tipi di documenti.",
      },
      ai: {
        title: "IA Integrata",
        description: "Classificazione ed estrazione automatica dei dati chiave.",
      },
      speed: {
        title: "Elaborazione Ultra-Veloce",
        description: "Migliaia di pagine elaborate in pochi minuti.",
      },
      accuracy: {
        title: "Massima Precisione",
        description: "Tasso di riconoscimento superiore al 99%.",
      },
    },
    cta: "Scopri Sparkle",
    ctaFulltext: "Indicizzazione Full-text",
    ctaFulltextDesc: "Cerca istantaneamente in tutti i tuoi documenti.",
    ctaScan: "Scansione Lampo → Cartella",
    ctaScanDesc: "Scansiona e organizza in un batter d'occhio.",
  },
  testimonials: {
    badge: "Testimonianze",
    title: "Si Fidano di Noi",
    subtitle: "Scopri come i nostri clienti trasformano la loro azienda con VEECTORIA",
    items: [
      { quote: "Grazie a VEECTORIA, abbiamo ridotto le attività amministrative del 70%.", metric: "-70%", metricLabel: "tempo admin", name: "Isabelle G.", role: "Responsabile Amministrativa" },
      { quote: "L'agente IA commerciale ha trasformato la nostra prospezione. +40% appuntamenti qualificati.", metric: "+40%", metricLabel: "appuntamenti qualificati", name: "Marc D.", role: "Direttore Commerciale" },
      { quote: "La soluzione documentale ci fa risparmiare tempo prezioso nella gestione dei fascicoli.", metric: "5x", metricLabel: "più veloce", name: "Sophie M.", role: "Titolare" },
    ],
  },
  faq: {
    badge: "Domande Frequenti",
    title: "Tutto su VEECTORIA",
    subtitle: "Risposte alle tue domande più comuni",
    items: {
      q1: { question: "Cos'è un Agente IA VEECTORIA?", answer: "Un collaboratore virtuale intelligente addestrato sui tuoi specifici processi aziendali." },
      q2: { question: "Quanto tempo richiede la distribuzione?", answer: "La distribuzione standard richiede 2-4 settimane, per esigenze più complesse 6-8 settimane." },
      q3: { question: "I miei dati sono sicuri?", answer: "Assolutamente. Tutti i dati sono ospitati in Europa su server certificati, 100% conformi al GDPR." },
      q4: { question: "Qual è il ritorno sull'investimento atteso?", answer: "I nostri clienti vedono un guadagno di produttività del 40% e ROI positivo in 3 mesi." },
      q5: { question: "Come funziona l'integrazione?", answer: "VEECTORIA si integra nativamente con oltre 200 strumenti professionali." },
    },
  },
  contact: {
    badge: "Contattaci",
    title: "Pronto a Trasformare la Tua Azienda?",
    subtitle: "Parliamo delle tue esigenze e scopri come VEECTORIA può supportarti",
    form: {
      name: "Nome completo",
      email: "Email professionale",
      company: "Azienda",
      phone: "Telefono",
      message: "Il tuo messaggio",
      submit: "Invia messaggio",
      sending: "Invio in corso...",
      success: "Messaggio inviato con successo!",
      error: "Errore nell'invio. Riprova.",
    },
    info: { title: "Informazioni di Contatto", email: "Email", phone: "Telefono", address: "Indirizzo" },
  },
  cta: {
    title: "Pronto ad Agire?",
    subtitle: "Unisciti alle aziende che hanno già trasformato la loro produttività con VEECTORIA",
    button: "Recluta un Agente IA",
  },
  footer: {
    description: "Soluzioni di intelligenza artificiale per trasformare la tua azienda.",
    navigation: "Navigazione",
    legal: "Note Legali",
    privacy: "Privacy Policy",
    terms: "Termini e Condizioni",
    cookies: "Impostazioni Cookie",
    rights: "Tutti i diritti riservati.",
  },
  agents: {
    badge: "Il Nostro Team",
    title: "I Nostri Agenti IA",
    subtitle: "Scopri i nostri collaboratori virtuali pronti a unirsi al tuo team",
  },

  // AI Agents Showcase
  agentsShowcase: {
    badge: "L'Eccellenza dell'IA al Servizio della Tua Azienda",
    title: "I Nostri Agenti IA Trasformano la Tua Quotidianità",
    description: "Immagina un team di collaboratori virtuali che non dorme mai, impara continuamente e si adatta perfettamente ai tuoi processi aziendali. I nostri Agenti IA amplificano le tue capacità, liberano i tuoi talenti dalle attività ripetitive e portano la tua produttività a nuovi livelli.",
    imageAlt: "Team Agenti IA VEECTORIA",
    cta: "Scopri i Nostri Agenti",
    benefits: {
      availability: "Disponibili 24/7",
      productivity: "Produttività x10",
      performance: "Performance Ottimale",
      collaboration: "Collaborazione Fluida",
    },
  },
  cookies: {
    title: "Gestione dei cookie",
    message: "Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito, analizzare il traffico e personalizzare i contenuti.",
    accept: "Accetta tutto",
    decline: "Rifiuta",
    settings: "Personalizza",
    settingsTitle: "Impostazioni cookie",
    settingsDescription: "Gestisci le tue preferenze sui cookie. I cookie essenziali sono necessari per il funzionamento del sito e non possono essere disattivati.",
    saveChoices: "Salva le mie scelte",
    rejectAll: "Rifiuta tutto",
    alwaysActive: "Sempre attivo",
    categories: {
      essential: { name: "Cookie essenziali", description: "Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati." },
      analytics: { name: "Cookie analitici", description: "Questi cookie ci permettono di misurare il pubblico del sito e analizzare il comportamento di navigazione." },
      marketing: { name: "Cookie di marketing", description: "Questi cookie vengono utilizzati per offrire pubblicità personalizzata." },
      preferences: { name: "Cookie di preferenza", description: "Questi cookie memorizzano le tue preferenze (lingua, tema, regione)." },
    },
  },

  // Partners Section
  partners: {
    badge: "Programma Partner",
    title: "Sviluppiamo Insieme",
    description: "Sei un rivenditore, distributore, editore software o grossista? VEECTORIA diventa il tuo partner tecnologico privilegiato per conquistare nuovi mercati con soluzioni di intelligenza artificiale all'avanguardia.",
    valueProposition: "Progettiamo e sviluppiamo soluzioni professionali complete e personalizzate per i tuoi clienti, supportandoti nell'implementazione di una strategia di commercializzazione di massa. Margini attraenti, supporto tecnico dedicato e assistenza marketing: tutti gli ingredienti per il tuo successo.",
    types: {
      resellers: { title: "Rivenditori", description: "Integra le nostre soluzioni IA nel tuo catalogo e offri pacchetti differenzianti." },
      distributors: { title: "Distributori", description: "Distribuisci le nostre tecnologie su larga scala nel tuo territorio." },
      editors: { title: "Editori Software", description: "Arricchisci il tuo software con la nostra IA per un valore aggiunto incomparabile." },
      wholesalers: { title: "Grossisti", description: "Accedi a tariffe preferenziali per la distribuzione di massa nelle tue reti." },
    },
    benefits: {
      title: "I Tuoi Vantaggi Partner",
      whiteLabel: "Soluzioni white-label",
      support: "Supporto tecnico dedicato",
      scalability: "Scalabilità illimitata",
    },
    cta: "Diventa Partner",
    ctaSubtext: "Contattaci per scoprire il nostro programma partner esclusivo",
  },

  legal: {
    lastUpdate: "Ultimo aggiornamento: Gennaio 2026",
    mentions: {
      title: "Note Legali",
      sections: {
        editor: { title: "1. Editore del sito", intro: "Questo sito è editato da:", companyName: "Ragione sociale", legalForm: "Forma giuridica", capital: "Capitale sociale", address: "Sede legale", siren: "SIREN", siret: "SIRET", rcs: "RCS", tva: "P.IVA", naf: "Codice NAF" },
        publication: { title: "2. Direttore della pubblicazione", intro: "La pubblicazione è diretta da:", since: "dal" },
        contact: { title: "3. Contatto", phone: "Telefono", email: "Email" },
        hosting: { title: "4. Hosting", intro: "Il sito è ospitato da:", name: "Nome", address: "Indirizzo" },
        intellectual: { title: "5. Proprietà intellettuale", content1: "Questo sito è soggetto alla legislazione francese e internazionale sul diritto d'autore e proprietà intellettuale.", content2: "La riproduzione di questo sito, totale o parziale, è severamente vietata senza autorizzazione espressa di" },
        liability: { title: "6. Limitazione di responsabilità", content: "Le informazioni su questo sito sono il più accurate possibile. {company} non può essere ritenuta responsabile per danni diretti o indiretti derivanti dall'uso di questo sito." },
        law: { title: "7. Legge applicabile", content: "Questo sito è soggetto alla legge francese. In caso di controversia, i tribunali francesi avranno giurisdizione esclusiva." },
      },
    },
    privacy: {
      title: "Informativa sulla Privacy",
      sections: {
        intro: { title: "1. Introduzione", content: "{company} si impegna a proteggere la privacy degli utenti del suo sito web. Questa informativa spiega come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali in conformità con il GDPR." },
        controller: { title: "2. Titolare del trattamento", company: "Azienda", address: "Indirizzo", email: "Email" },
        data: { title: "3. Dati raccolti", intro: "Raccogliamo i seguenti dati:", items: ["Dati identificativi: nome, cognome, email, telefono", "Dati professionali: azienda, posizione", "Dati di navigazione: indirizzo IP, cookie, pagine visitate", "Dati di comunicazione: messaggi tramite moduli"] },
        purposes: { title: "4. Finalità del trattamento", intro: "I tuoi dati vengono raccolti per:", items: ["Rispondere alle tue richieste di contatto", "Fornire i nostri servizi IA", "Migliorare il nostro sito", "Inviare comunicazioni commerciali (con il tuo consenso)", "Adempiere agli obblighi legali"] },
        basis: { title: "5. Base giuridica", intro: "Il trattamento si basa su:", items: ["Il tuo consenso esplicito", "Esecuzione di un contratto", "Il nostro legittimo interesse", "Obblighi legali"] },
        retention: { title: "6. Periodo di conservazione", content: "I tuoi dati vengono conservati per il tempo necessario, massimo 3 anni dall'ultimo contatto." },
        rights: { title: "7. I tuoi diritti", intro: "In conformità con il GDPR, hai i seguenti diritti:", access: "Diritto di accesso", accessDesc: "ottenere una copia dei tuoi dati", rectification: "Diritto di rettifica", rectificationDesc: "correggere dati inesatti", erasure: "Diritto alla cancellazione", erasureDesc: "richiedere la cancellazione dei tuoi dati", restriction: "Diritto alla limitazione", restrictionDesc: "limitare il trattamento", portability: "Diritto alla portabilità", portabilityDesc: "ricevere dati in formato strutturato", objection: "Diritto di opposizione", objectionDesc: "opporsi al trattamento", contact: "Per esercitare questi diritti, contattaci:" },
        security: { title: "8. Sicurezza", content: "Implementiamo misure tecniche e organizzative appropriate per proteggere i tuoi dati." },
        complaint: { title: "9. Reclamo", content: "Puoi presentare un reclamo alla CNIL: www.cnil.fr" },
      },
    },
    cgv: {
      title: "Termini e Condizioni",
      sections: {
        object: { title: "1. Oggetto", content: "Questi Termini regolano i rapporti contrattuali tra {company} e i suoi clienti per servizi IA, sviluppo software e soluzioni aziendali." },
        provider: { title: "2. Fornitore", company: "Azienda", siret: "SIRET", address: "Indirizzo" },
        services: { title: "3. Servizi offerti", intro: "{company} offre i seguenti servizi:", items: ["Agenti IA specializzati", "Applicazioni aziendali personalizzate (Prime Evolution)", "Soluzioni IA documentali", "VEECTORIA Pulse - Piattaforma di trascrizione", "Consulenza e integrazione IA"] },
        quotes: { title: "4. Preventivi e ordini", content: "Tutti i servizi sono soggetti a un preventivo dettagliato." },
        pricing: { title: "5. Prezzi e pagamento", content1: "Prezzi in euro IVA esclusa. IVA al 20%. Pagabile in 30 giorni.", content2: "In caso di ritardo, verranno applicati interessi di mora." },
        delivery: { title: "6. Consegna e tempistiche", content: "I tempi sono indicativi. {company} si impegna a rispettare le scadenze concordate." },
        intellectual: { title: "7. Proprietà intellettuale", content: "Gli sviluppi rimangono proprietà di {company} fino al pagamento completo." },
        confidentiality: { title: "8. Riservatezza", content: "Entrambe le parti si impegnano alla riservatezza per 3 anni dopo la fine del contratto." },
        liability: { title: "9. Limitazione di responsabilità", content: "La responsabilità di {company} è limitata al valore del contratto." },
        law: { title: "10. Legge applicabile", content: "Si applica la legge francese. Il foro competente è Parigi." },
      },
    },
    cookiesPolicy: {
      title: "Politica dei Cookie",
      sections: {
        what: { title: "1. Cos'è un cookie?", content: "Un cookie è un piccolo file di testo che viene inserito sul tuo dispositivo quando visiti un sito web." },
        types: { title: "2. Cookie utilizzati", intro: "Il nostro sito utilizza i seguenti cookie:", essential: "Cookie essenziali", essentialDesc: "Necessari per il funzionamento del sito.", analytics: "Cookie analitici", analyticsDesc: "Ci aiutano a capire l'utilizzo.", preferences: "Cookie di preferenza", preferencesDesc: "Memorizzano le tue scelte." },
        retention: { title: "3. Periodo di conservazione", content: "I cookie vengono conservati per un massimo di 13 mesi." },
        management: { title: "4. Gestione dei cookie", intro: "Puoi modificare le tue preferenze in qualsiasi momento:", items: ["Chrome: Impostazioni → Privacy → Cookie", "Firefox: Opzioni → Privacy → Cookie", "Safari: Preferenze → Privacy → Cookie", "Edge: Impostazioni → Cookie"] },
        contact: { title: "5. Contatto", content: "Per domande sui cookie, contattaci:" },
      },
    },
  },
};
